import * as React from 'react'
import {
  ShopLandingPageLayout,
  ShopLandingPageTextColor,
  ShopLandingPageImageOverlay,
} from '../CmsLandingPage.d'
import css from './BannerText.module.scss'

export interface BannerTextProps {
  children: React.ReactNode
  className?: string
  dataTestId?: string
  imageOverlay: ShopLandingPageImageOverlay
  layout: ShopLandingPageLayout
  textColor: ShopLandingPageTextColor
}

const BannerText = ({
  children,
  className,
  dataTestId,
  imageOverlay,
  layout,
  textColor,
}: BannerTextProps) => {
  if (!children) {
    return null
  }

  const [verticalAlign, horizontalAlign] = layout.split(' - ')
  const imageOverlayClass = `Overlay${imageOverlay}`
  const textColorClass = `Text${textColor}`

  const classes = `
    ${css.BannerText}
    ${className || ''}
    ${css[`Align${verticalAlign}`]}
    ${css[`Align${horizontalAlign}`]}
    ${css[textColorClass]}
    ${css[imageOverlayClass]}
  `

  return (
    <div className={classes} data-testid={dataTestId}>
      <div className={css.TextWrap}>{children}</div>
    </div>
  )
}

export default BannerText
